/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2569
 */

var r = require(/* 2570 */"./2570/index")
var i = require(/* 2574 */"./2574/index")(function (e, t, n) {
  r(e, t, n)
})
module.exports = i
